import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import Home from './pages/Home';
import ManageGames from './pages/ManageGames';
import EditGame from './pages/EditGame';
import { Authenticator } from '@aws-amplify/ui-react';
import ManageSchedule from './pages/ManageSchedule';
import SocialMedia from './pages/SocialMedia';
import AdminHeader from './components/AdminHeader';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#9c27b0',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Authenticator socialProviders={['google']}>
      {({ signOut, user }) => (
        <Router basename='/'>
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AdminHeader />
            <Box component="main" sx={{ flexGrow: 1, backgroundColor: 'background.default' }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/manage-games" element={<ManageGames />} />
                <Route path="/games/:id" element={<EditGame />} />
                <Route path="/manageschedule" element={<ManageSchedule />} />
                <Route path="/socialmedia" element={<SocialMedia />} />
                {/* Redirect old route for backwards compatibility */}
                <Route path="/managegames" element={<Navigate to="/manage-games" replace />} />
              </Routes>
            </Box>
          </Box>
        </Router>
      )}
    </Authenticator>
  </ThemeProvider>
);

export default App;
